// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1vIVw","content":"Consent_content__309--","footer":"Consent_footer__1AUiC"};